import { FC, useEffect, useState } from "react";
import WeekView from "./views/WeekView";
import { Avatar, Button, Form, Tooltip } from "antd";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedTeamMember,
  setDate,
} from "../../services/store/slices/calender";
import { getTeamMembersLocation } from "../../network/teamMember";
import { TeamMemberType } from "../../types/teamMember";
import SalonLocationsSelect from "../common/SalonLocationsSelect";
import DayView from "./views/DayView";
import QuickActionButton from "../common/QuickActionButton";
import { UserOutlined } from "@ant-design/icons";
import { UploadFile } from "antd/lib";

interface CalendarProps {}

const CalendarWrapper: FC<CalendarProps> = ({}) => {
  const dispatch = useDispatch();
  const { selectedTeamMember, locationId, currentLang, view } = useSelector(
    ({
      calendar,
      user,
    }: {
      calendar: {
        selectedTeamMember: number | null;
        locationId: number | null;
        view: "day" | "week" | "month";
      };
      user: {
        currentLang: "en" | "ar";
      };
    }) => {
      return {
        selectedTeamMember: calendar.selectedTeamMember,
        currentLang: user.currentLang,
        locationId: calendar.locationId,
        view: calendar.view,
      };
    }
  );
  const [activeTeamMember, setActiveTeamMember] =
    useState<TeamMemberType | null>(null);
  const { data: teamMembers } = useQuery(
    ["teamMembers", locationId],
    () => getTeamMembersLocation(locationId),
    {
      enabled: !!locationId,
    }
  );
  useEffect(() => {
    dispatch(setDate(new Date()));
  }, []);
  const changeSelectedTeamMember = (memberId: number | null) => {
    dispatch(setSelectedTeamMember(memberId));
    setActiveTeamMember(
      teamMembers?.data?.find(
        (member: TeamMemberType) => member?.id === memberId
      )
    );
  };
  useEffect(() => {
    if (selectedTeamMember) {
      setActiveTeamMember(
        teamMembers?.data?.find(
          (member: TeamMemberType) => member?.id === selectedTeamMember
        )
      );
    }
    //  else {
    //   setActiveTeamMember(teamMembers?.data?.[0]);
    // }
  }, [teamMembers]);
  const calendarViews = {
    week: <WeekView />,
    day: <DayView />,
    month: <h2>Not Yet</h2>,
  };
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const onFinish = (values: any) => {
    console.log(values);
  };
  return (
    <div className=" space-y-6 py-6 my-2 !w-[1272px] mx-auto">
      <div className="p-2  flex justify-between">
        <div>
          <SalonLocationsSelect />
        </div>
        <div className="flex items-center justify-between gap-3">
          <div className="relative  flex items-center gap-1 ">
            <Avatar.Group maxCount={4} size={30}>
              {Array.isArray(teamMembers?.data) && teamMembers?.data?.length > 0
                ? teamMembers?.data.map((member: TeamMemberType) =>
                    selectedTeamMember !== member?.id ? (
                      <Tooltip title={member?.name}>
                        <Avatar
                          icon={<UserOutlined />}
                          key={member?.id}
                          onClick={() => changeSelectedTeamMember(member?.id)}
                          style={{ backgroundColor: "gray" }}
                          className={
                            "hover:z-10 text-white cursor-pointer " +
                            (member?.id === selectedTeamMember ? " hidden" : "")
                          }
                          src={member?.media}
                        >
                          {member?.name?.split(" ")[0]?.charAt(0).toUpperCase()}

                          {member?.name?.split(" ")[1]?.charAt(0).toUpperCase()}
                        </Avatar>
                      </Tooltip>
                    ) : null
                  )
                : null}
            </Avatar.Group>
            {activeTeamMember ? (
              <Tooltip title={activeTeamMember?.name}>
                <Avatar
                  size={30}
                  style={{ backgroundColor: "gray" }}
                  className="  text-white ring-2 "
                  src={activeTeamMember?.media}
                  icon={<UserOutlined />}
                >
                  {activeTeamMember?.name
                    ?.split(" ")[0]
                    ?.charAt(0)
                    .toUpperCase()}

                  {activeTeamMember?.name
                    ?.split(" ")[1]
                    ?.charAt(0)
                    .toUpperCase()}
                </Avatar>
              </Tooltip>
            ) : null}
            <Avatar
              size={30}
              onClick={() => changeSelectedTeamMember(null)}
              className={
                "bg-color-primary text-white cursor-pointer   " +
                (selectedTeamMember === null
                  ? " ring-2  !bg-color-primary text-white"
                  : "bg-gray-100 shadow-xl !text-color-primary ")
              }
            >
              {currentLang === "ar" ? "الكل" : "All"}
            </Avatar>
          </div>
          <div>
            <QuickActionButton />
          </div>
        </div>
      </div>
      {calendarViews[view]}
    </div>
  );
};

export default CalendarWrapper;
